import { s } from '@/theme/tokens/spacing';
import { typeScale } from '@/theme/tokens/typography';

export const deltaIndicatorSx = {
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: typeScale.sm,
  marginLeft: s('sm'),
  lineHeight: 1,
} as const;
